import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hook";
import { setUiLanguage } from "../modules/auth/slices/userSlice";
import { useTranslation } from "react-i18next";
import Select from "./Select";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { uiLanguage } from "../modules/auth/selectors/userSelector";

export default function LanguageSwitch() {
  const dispatch = useAppDispatch();
  const locale = useAppSelector(uiLanguage);
  const [language, setLanguage] = useState(locale);
  const [translate] = useTranslation();
  const languages = process.env.REACT_APP_SUPPORTED_LANGUAGES;
  const languagesArray = languages ? languages.split(",") : ["lt"];
  const options = languagesArray.map((language) => ({
    value: language,
    label: translate(language),
  }));

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const selectedValue = event.target.value;
    dispatch(setUiLanguage(selectedValue));
    setLanguage(selectedValue);
  };

  return (
    <Select
      options={options}
      onChange={handleChange}
      value={language}
      fullWidth={false}
      variant="standard"
      selectIcon={ArrowDropDownOutlinedIcon}
      InputProps={{ disableUnderline: true }}
    />
  );
}
